import env from '@tencent/vft-common/env';

export function setIpxClass(root = document.body): void {
  // Define the users device screen dimensions
  const screen = {
    width: window.screen.width,
    height: window.screen.height,
  };

  // 适配iphone12 | 12 pro | 12 pro max
  const iphone12 = (screen.width === 390 && screen.height === 844)
    || (screen.width === 844 && screen.height === 390)
    || (screen.width === 428 && screen.height === 926)
    || (screen.width === 926 && screen.height === 428);
  // iPhone X Detection
  if (
    env.isIos
    && ((screen.width === 375 && screen.height === 812)
      || (screen.width === 812 && screen.height === 375)
      || iphone12)
  ) {
    root.classList.add('ipx');
  }

  // iPhone X Max Detection
  if (
    env.isIos
    && ((screen.width === 414 && screen.height === 896)
      || (screen.width === 896 && screen.height === 414))
  ) {
    root.classList.add('ipx');
    root.classList.add('ipx-max');
  }
}

/**
 * 注入额外样式配置
 */
export function setExtraStyle(css: string) {
  if (!css) return;
  let style = document.getElementById('extra-style');
  if (!style) {
    style = document.createElement('style');
    style.id = 'extra-style';
    /* eslint-disable */
    document.getElementsByTagName('head')?.[0]?.appendChild?.(style);
  }
  style.innerHTML = css;
}
